import React from 'react'
import { findDOMNode } from 'react-dom'
import { observer,inject } from 'mobx-react'

import Drawer from 'material-ui/Drawer'
import Grid from 'material-ui/Grid'
import classNames from 'classnames'
import PropTypes from 'prop-types';
import { withStyles } from 'material-ui/styles'
import Paper from 'material-ui/Paper'
import Typography from 'material-ui/Typography'
import Button from 'material-ui/Button'
import Icon from 'material-ui/Icon'
import IconButton from 'material-ui/IconButton'
import T from 'i18n-react'
import ListSubheader from 'material-ui/List/ListSubheader'
import List, { ListItem, ListItemIcon, ListItemText, ListItemSecondaryAction } from 'material-ui/List'
import Avatar from 'material-ui/Avatar'
import Tooltip from 'material-ui/Tooltip'
import { withRouter } from 'react-router'
import { Link } from 'react-router-dom'
import Input, { InputLabel } from 'material-ui/Input'
import { FormControl, FormHelperText } from 'material-ui/Form'
import { indigo } from 'material-ui/colors'
import Popover from 'material-ui/Popover'
import TextField from 'material-ui/TextField'
import Dialog, {
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from 'material-ui/Dialog'
import Menu, { MenuItem } from 'material-ui/Menu'
import QRCode from 'qrcode.react'

import CartItemCount from './cartitemcount'


@inject('store','ui') @observer
class Cart extends React.Component {
  render () {
    const ui = this.props.ui.cart, { classes } = this.props, open = ui.isOpen()

    return (
     <Drawer
      anchor="bottom"
      open={open}
      onClose={ui.handleCloseCart}
      classes={{
        paper: classes.drawerPaper,
      }}
     >
      <CartContent classes={classes} history={this.props.history} />
     </Drawer>
    )
  }
}

@inject('ui') @observer
class CartContent extends React.Component {
  render () {
    const { classes,history } = this.props
    return (
      <div className={classes.cartContainer}>
       <CartItemCount showInCart={true} />
       <div className={classes.contentContainer}>
        <Grid container>
         <Grid item xs={4}> <ClearCartButton /> </Grid>
         <Grid item xs={8}>
         <Grid container direction="row" justify="flex-end" alignitems="flex-start">
          <Grid item>

           <ToCollectionButton />
           <QRCodeButton />
           <PDFCollectionButton />
           <EmailCollectionButton />
           <PublishCollectionButton />

          </Grid>
         </Grid>
         </Grid>
        </Grid>

        <SharingContainer />
        <LessonCount classes={classes} />
        <ItemList classes={classes} history={history} />
        <SendEmailDialog />
        <PDFMenu />
        <QRCodeDialog />
        <TitleAndDescriptionDialog />

       </div>
      </div>
    )
  }
}


@inject('store') @observer
class LessonCount extends React.Component {
  render () {
    const cart = this.props.store.cart, classes = this.props.classes
    return (
      <Typography component="p" display="headline" className={classes.lessonCount}>
       {cart.lessonCount}
      </Typography>
    )
  }
}

@inject('store','ui') @observer
class SharingContainer extends React.Component {
  render () {
    const cart = this.props.store.cart
    return (
      <div className="callout" style={{marginTop:0}}>
       <FormControl fullWidth>
        <Input value={cart.sharelink} onFocus={this.handleFocus} />
        <FormHelperText> {this.props.store.collectionName} - {T.translate("meta.link")} </FormHelperText>
       </FormControl>
      </div>
    )
  }

  handleFocus (e) {
    e.target.select()
  }

}

@inject('store') @observer
class ClearCartButton extends React.Component {
  render () {
    const { store } = this.props
    return (
      <Button color="secondary" onClick={store.cart.clearAll}>
       <Icon>clear_all</Icon> <span style={{paddingLeft:5}}> {T.translate('meta.removeAll')} </span>
      </Button>
    )
  }
}

@inject('ui') @observer
class ToCollectionButton extends React.Component {
  render () {
    const { ui } = this.props

    return (
     <Tooltip id={"tooltip-to"} title={T.translate("cart.toCollection")} placement="bottom">
       <IconButton color="secondary" onClick={ui.cart.handleOpenTitleAndDescriptionDialog}>
        <Icon>reply</Icon>
       </IconButton>
     </Tooltip>
    )
  }
}

@inject('store','ui','newcollectionformstore') @observer
class PublishCollectionButton extends React.Component {
  render () {
    return (
     <Tooltip id={"tooltip-pub"} title={T.translate("cart.publishCollection")} placement="bottom">
      <IconButton color="secondary" onClick={this.openNewCollectionForm}>
       <Icon>public</Icon>
      </IconButton>
     </Tooltip>
    )
  }

  openNewCollectionForm = () => {
    this.props.store.setCollectionFormAsSuggestion()
    this.props.newcollectionformstore.clear()
    this.props.ui.newCollectionForm.handleOpen()
  }
}

@inject('ui') @observer
class QRCodeButton extends React.Component {
  render () {
    const ui = this.props.ui.cart
    return (
     <Tooltip id={"tooltip-to"} title={T.translate("cart.qrCode")} placement="bottom">
      <IconButton color="secondary" onClick={ui.handleOpenQRCodeDialog}>
       <Icon>smartphone</Icon>
      </IconButton>
     </Tooltip>
    )
  }
}

@inject('store','ui') @observer
class QRCodeDialog extends React.Component {
  render () {
    const ui = this.props.ui.cart, store = this.props.store.cart
    return (
      <Dialog
       open={ui.openQRCodeDialog}
       keepMounted
       onClose={ui.handleCloseQRCodeDialog}
      >
       <DialogContent>
        <QRCode value={store.sharelink} size={256} />
       </DialogContent>

     </Dialog>
    )
  }
}

@inject('store','ui') @withRouter @observer
class TitleAndDescriptionDialog extends React.Component {
  render () {
    const ui = this.props.ui.cart, store = this.props.store.cart
    return (
      <Dialog
       open={ui.openTitleAndDescriptionDialog}
       keepMounted
       onClose={ui.handleCloseTitleAndDescriptionDialog}
      >
       <DialogContent>
        <Typography component="p" type="caption"> {T.translate("cart.onTheFlyTitleAndDescription")} </Typography>
        <Input type="text" value={store.title} onChange={this.setTitle} placeholder={T.translate("cart.publishTitle")} fullWidth/>
        <Input
         type="text"
         value={store.description}
         onChange={this.setDescription}
         placeholder={T.translate("cart.publishDescription")}
         fullWidth
         multiline
         rows={3}
        />
       </DialogContent>
       <DialogActions>
        <Button onClick={ui.handleCloseTitleAndDescriptionDialog} color="primary">
         {T.translate("meta.close")}
        </Button>
        <Button color="secondary" onClick={this.goToCollection}>
         {T.translate("cart.toCollection")}
        </Button>
      </DialogActions>

     </Dialog>
    )
  }

  setTitle = (e) => {
    this.props.store.cart.setTitle(e.target.value)
  }
  setDescription = (e) => {
    this.props.store.cart.setDescription(e.target.value)
  }
  goToCollection = (e) => {
    this.props.history.push(this.props.store.cart.relativeSharelink)
    this.props.ui.cart.handleCloseTitleAndDescriptionDialog()
    this.props.ui.cart.handleCloseCart()
  }
}

@inject('ui') @observer
class PDFCollectionButton extends React.Component {
  render () {
    const ui = this.props.ui.cart
    return (
     <Tooltip id={"tooltip-pdf"} title={T.translate("cart.publishPDF")} placement="bottom">
      <IconButton color="secondary" onClick={this.setPDFMenuAnchorEl}>
       <Icon>print</Icon>
      </IconButton>
     </Tooltip>
    )
  }

  setPDFMenuAnchorEl = (e) => {
    this.props.ui.cart.setPDFMenuAnchorEl(e.currentTarget)
  }
}

@inject('ui','store') @observer
class PDFMenu extends React.Component {
  render () {
    const ui = this.props.ui.cart, store = this.props.store.cart
    return (
     <Menu
      id="pdf-menu"
      anchorEl={ui.pdfMenuAnchorEl}
      open={Boolean(ui.pdfMenuAnchorEl)}
      onClose={this.setPDFMenuAnchorEl}
     >
      <MenuItem onClick={this.setPDFMenuAnchorEl}>
       <Link to={store.pdfLinkTeacher} className="unstyle-a"> {T.translate("cart.publishPDFTeacher")} </Link>
      </MenuItem>
      <MenuItem onClick={this.setPDFMenuAnchorEl}>
       <Link to={store.pdfLinkPupils} className="unstyle-a"> {T.translate("cart.publishPDFPupils")} </Link>
      </MenuItem>
      <MenuItem onClick={this.setPDFMenuAnchorEl}>
       <Link to={store.pdfLinkPupilsAndTeacher} className="unstyle-a"> {T.translate("cart.publishPDFPupilsAndTeacher")} </Link>
      </MenuItem>
     </Menu>
    )
  }

  setPDFMenuAnchorEl = (e) => {
    this.props.ui.cart.setPDFMenuAnchorEl(null)
  }

}


@inject('ui') @observer
class EmailCollectionButton extends React.Component {
  render () {
    const ui = this.props.ui.cart
    return (
     <Tooltip id={"tooltip-mail"} title={T.translate("cart.mailCollection")} placement="bottom">
      <IconButton color="secondary" onClick={ui.handleOpenEmailDialog}>
       <Icon>mail_outline</Icon>
      </IconButton>
     </Tooltip>
    )
  }
}

@inject('store','ui','messenger') @observer
class SendEmailDialog extends React.Component {
  render () {
    const ui = this.props.ui.cart, store = this.props.store.cart
    return (
      <Dialog
       open={ui.openEmailDialog}
       keepMounted
       onClose={ui.handleCloseEmailDialog}
      >
       <DialogContent>
        <DialogContentText> {T.translate("cart.mailCollection")} </DialogContentText>
        <Typography component="p" type="caption"> {T.translate("cart.mailCollectionDescription")} </Typography>
        <Input type="email" value={store.mailToSendCart} onChange={this.setMailToSendCart} fullWidth/>
       </DialogContent>
       <DialogActions>
        <Button onClick={ui.handleCloseEmailDialog} color="primary">
         {T.translate("meta.close")}
        </Button>
        <Button onClick={this.sendMailWithCartInfos} color="secondary">
         {T.translate("meta.send")}
        </Button>
      </DialogActions>
     </Dialog>
    )
  }

  sendMailWithCartInfos = () => {
    this.props.store.cart.sendMailWithCartInfos((res) => {
      if (res.success) {
       this.props.messenger.handleOpen(this.props.messenger.messages.SEND_MAIL)
      }
    })
    this.props.ui.cart.handleCloseEmailDialog()
  }

  setMailToSendCart = (e) => {
    this.props.store.cart.setMailToSendCart(e.target.value)
  }

}

@inject('store','ui') @withRouter @observer
class ItemList extends React.Component {
  render () {
    const { store,ui,classes } = this.props, cart = store.cart
    return (
     <List className={classes.itemList}>
       {cart.getItemsGroupedByItemType().map( (group,i) => (
        <div key={i} className={classes.listSection}>
         <ListSubheader> {group[0].type.name} </ListSubheader>
         {group.map( (item,j) => {

           return (
             <ListItem dense button onClick={this.listitemevent.bind(this,item)} key={j}>
              <Avatar alt={item.title} src={item.image} />
              <ListItemText primary={item.title} secondary={store.getApproximatedTimevalue(item)}/>

              <ListItemSecondaryAction>
               <Tooltip id={"tooltip-"+j} title={T.translate("meta.remove")} placement="left">
                <IconButton color="secondary" aria-label="remove" onClick={cart.removeItem.bind(this,item)}>
                 <Icon>remove_circle_outline</Icon>
                </IconButton>
               </Tooltip>
              </ListItemSecondaryAction>
             </ListItem>
           )
          }
         )}
        </div>
       ))}
     </List>
    )
  }

  listitemevent (item) {
    const pathname = this.props.store.getItemTitleAsURLString(item.id,item.title)
    this.props.history.push(pathname)
  }
}


@inject('store','ui') @observer
export class AddToCartButton extends React.Component {
  render () {
    const { store,ui,atCatalogView,atDetailView,item } = this.props,
          isInCart = store.cart.hasItem(item.id)
    const icon = isInCart ? "remove_circle_outline" : "add_circle_outline",
          text = isInCart ? T.translate('cart.removeFromCart') : T.translate('cart.addToCart')

    let addToCartButton = null

    if (atDetailView) {
      addToCartButton =
       <Button color="secondary" onClick={store.cart.toggleItem.bind(this,item)}>
        <Icon> {icon} </Icon> <span style={{paddingLeft:5}}> {text} </span>
       </Button>
    }

    else if (atCatalogView) {
     addToCartButton =
      <IconButton color="secondary" className="catalog-item-add" onClick={store.cart.toggleItem.bind(this,item)}>
       <Icon> {icon} </Icon>
      </IconButton>
    }

    return ( addToCartButton )
  }
}

@inject('store') @observer
export class AddCollectionToCartButton extends React.Component {
  render () {
    const { store,atDetailView,atCatalogView,collection } = this.props
    const hasTheseItems = store.cart.hasTheseItems(collection.items)
    const icon = hasTheseItems ? "remove_circle_outline" : "add_circle_outline",
          text = hasTheseItems ? T.translate('cart.removeFromCart') : T.translate('cart.addToCart')

    let addToCartButton = null

    if (atDetailView) {
     addToCartButton =
      <Button
       color="secondary"
       onClick={this.toggleCollection}
      >
       <Icon>{icon}</Icon>
       <span style={{paddingLeft:5}}> {text} </span>
      </Button>
    }

    else if (atCatalogView) {
     addToCartButton =
      <IconButton color="secondary" className="catalog-item-add" onClick={this.toggleCollection}>
       <Icon> {icon} </Icon>
      </IconButton>
    }

    return (addToCartButton)
  }

  toggleCollection = (e) => {
    this.props.store.getItems(this.props.collection.items, (c) => {
      this.props.store.cart.toggleCollection(c.items)
    })
  }
}




const styles = theme => ({
 drawerPaper: {
  left:'unset',
  width: '100vw',
  [theme.breakpoints.up('md')]: {
    width: '50vw',
    marginRight:'10%',
  },
 },
 itemList: {
  width: '100%',
  background: theme.palette.background.paper,
  position: 'relative',
  overflow: 'auto',
  maxHeight:'40vh'
 },
 itemListSection: {
  background: 'inherit',
 },
 cartContainer:{
   maxHeight:"80vh",
   overflow:"hidden"
 },
 contentContainer:{
   marginTop:60
 },
 lessonCount:{
   textAlign:'center',
 },
 publishPopoverContainer:{
   padding:20
 },
 publishButton:{
   width:"100%"
 }
})

Cart.propTypes = {
  classes: PropTypes.object.isRequired,
  theme: PropTypes.object.isRequired,
}

export default withStyles(styles, { withTheme: true })(withRouter(Cart))



// WEBPACK FOOTER //
// ./src/components/cart.js